import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FilterPayload } from '../../models/filter-payload.model'; // Adjust path
import { EligibleSystemResponse } from '../../models/EligibleSystem.model';

export interface FilterCriteriaFormData {
  notes: string;
  commonTemplate: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private filterSubject = new BehaviorSubject<FilterPayload | null>(null);
  filter$ = this.filterSubject.asObservable();

  private selectedColumnsSubject = new BehaviorSubject<string[]>([]);
  selectedColumns$ = this.selectedColumnsSubject.asObservable();
  
  private testRunTriggeredSubject = new BehaviorSubject<boolean>(false);
  testRunTriggered$ = this.testRunTriggeredSubject.asObservable();
  
  private testRunSourceSubject = new BehaviorSubject<'manual' | 'llm'>('manual');
  testRunSource$ = this.testRunSourceSubject.asObservable();
  
  private activeQueryTabSubject = new BehaviorSubject<'manual' | 'llm'>('manual');
  activeQueryTab$ = this.activeQueryTabSubject.asObservable();

  readonly pendingNavigationSubject = new BehaviorSubject<string | null>(null);
  pendingNavigation$ = this.pendingNavigationSubject.asObservable();
  
  latestPayload: FilterPayload | null = null;
  mockedEligibleSystemsResponse: EligibleSystemResponse | null = null;
  useMatchedMockResponse: boolean = false;
  filterFormData: FilterCriteriaFormData = {
    notes: '',
    commonTemplate: null
  };

  private autoSaveCallback: (() => Promise<boolean>) | null = null;
  private hasChangesCallback: (() => boolean) | null = null;


  updateTableData(payload: FilterPayload): void {
    this.latestPayload = payload;
    this.filterSubject.next(payload);
  }

  setSelectedColumns(columns: string[]): void {
    this.selectedColumnsSubject.next(columns);
  }

  updateFilterFormData(formData: Partial<FilterCriteriaFormData>): void {
    this.filterFormData = { ...this.filterFormData, ...formData };
  }

  getFilterFormData(): FilterCriteriaFormData {
    return this.filterFormData;
  }

  triggerTestRun(payload: FilterPayload, source: 'manual' | 'llm' = 'manual'): void {
    this.latestPayload = payload;
    this.filterSubject.next(payload);
    this.testRunSourceSubject.next(source);
    this.testRunTriggeredSubject.next(true);
  }

  resetTestRun(): void {
    this.testRunTriggeredSubject.next(false);
  }

  notifyTabSwitch(tab: 'manual' | 'llm'): void {
    this.activeQueryTabSubject.next(tab);
  }

  registerAutoSave(callback: () => Promise<boolean>): void {
    this.autoSaveCallback = callback;
  }

  registerHasChanges(callback: () => boolean): void {
    this.hasChangesCallback = callback;
  }

  unregisterAutoSave(): void {
    this.autoSaveCallback = null;
  }

  unregisterHasChanges(): void {
    this.hasChangesCallback = null;
  }

  triggerAutoSave(): Promise<boolean> {
    if (this.autoSaveCallback) {
      return this.autoSaveCallback();
    }
    return Promise.resolve(true);
  }

  checkHasChanges(): boolean {
    if (this.hasChangesCallback) {
      return this.hasChangesCallback();
    }
    return false;
  }

  triggerUnsavedChangesForNavigation(url: string): void {
  this.pendingNavigationSubject.next(url);
}

clearPendingNavigation(): void {
  this.pendingNavigationSubject.next(null);
}
}